import React, { Component } from 'react';
import { showNotification } from '../../StatusNotification';
import { showConfirmation } from '../../ConfirmationModal';
import './securesubmissions.css';

/*
 * Decrypted view of a single submission. The server decrypts (and audit-logs)
 * the access after re-verifying the Staff/Admin role. "Mark Complete" purges
 * the encrypted data immediately and irreversibly.
 */
export class SecureSubmissionDetail extends Component {
    static displayName = SecureSubmissionDetail.name;

    constructor(props) {
        super(props);
        this.state = {
            submission: null,
            ready: false,
            authorized: true
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    submissionId() {
        return this.props.match.params.submissionId;
    }

    async getComponentData() {
        const response = await fetch('SecureSubmission/GetSubmission/' + this.submissionId(), {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        });

        if (response.status === 401) {
            this.setState({ authorized: false, ready: true });
            return;
        }
        if (response.status === 404) {
            this.setState({ submission: null, ready: true });
            return;
        }

        const data = await response.json();
        this.setState({ submission: data, ready: true });
    }

    markComplete = async () => {
        let confirmed = await showConfirmation(
            "Mark this submission complete? This permanently purges the encrypted data and cannot be undone.");
        if (!confirmed) return;

        const response = await fetch('SecureSubmission/MarkComplete/' + this.submissionId(), {
            method: 'POST',
            headers: { 'Accept': 'application/json' }
        });

        if (response.status === 401) {
            showNotification("You are not authorized to perform this action.", "error");
            return;
        }

        if (response.ok) {
            showNotification("Submission marked complete and purged.", "success");
            this.getComponentData();
        } else {
            showNotification("Unable to mark submission complete.", "error");
        }
    }

    renderValue(value) {
        if (value != null && typeof value === 'string' && value.indexOf('data:image') === 0) {
            return <img src={value} alt="Signature" className='secure-signature-img' />;
        }
        return <span>{value}</span>;
    }

    render() {
        if (!this.state.ready) {
            return <div className='secure-submissions-container'><p>Loading...</p></div>;
        }

        if (!this.state.authorized) {
            return (
                <div className='secure-submissions-container'>
                    <div className='page-title'><h1>Secure Submission</h1></div>
                    <p role='alert'>You do not have permission to view this submission.</p>
                </div>
            );
        }

        let submission = this.state.submission;
        if (submission == null) {
            return (
                <div className='secure-submissions-container'>
                    <div className='page-title'><h1>Secure Submission</h1></div>
                    <p>Submission not found.</p>
                </div>
            );
        }

        let isPurged = submission.purged || submission.content === null;
        let fields = submission.fields || [];

        return (
            <div className='secure-submissions-container'>
                <div className='page-title'><h1>Secure Submission #{submission.id}</h1></div>

                {isPurged
                    ? <p className='badge-purged'>This submission has been completed and its data purged.</p>
                    : (
                        <>
                            <dl className='secure-submission-fields'>
                                {fields.map((f, idx) => (
                                    <div className='secure-field-row' key={idx}>
                                        <dt>{f.fieldName}</dt>
                                        <dd>{this.renderValue(f.fieldValue)}</dd>
                                    </div>
                                ))}
                            </dl>

                            <button className='secure-complete-btn' onClick={this.markComplete}>
                                Mark Complete &amp; Purge
                            </button>
                        </>
                    )}
            </div>
        );
    }
}

export default SecureSubmissionDetail;
